export const getHeaders = (tipooferta) => {

  return [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "art_descripcion", headerName: "Descripcion", width: 250 },
    { field: "aofd_art_nprecio", headerName: "Precio", width: 120 },
    { field: "aofd_ofertaprecio", headerName: "Precio De Oferta", width: 120 },
    ...(Number(tipooferta) === 1
      ? [{ field: "aofd_ofertastock", headerName: "Stock De Oferta", width: 120 }]
      : []),
  ];
};


